(function($){
  $(function(){
    if (window.location.hash) { 
        var fragment = window.location.hash.substring(1);
        if (fragment != '') {
            // 監視対象となるノードを指定
            var targetNode = document.body;

            // オブザーバーの設定を作成
            var config = { attributes: true, childList: false, subtree: true };

            // コールバック関数を定義
            var callback = function(mutationsList, observer) {
                for(var mutation of mutationsList) {
                    console.log(fragment);
                    console.log(mutation.target.id);
                    if(fragment == mutation.target.id && mutation.type === 'attributes' && mutation.attributeName === 'id') {
                      $('html, body').animate({
                          scrollTop: $(mutation.target).offset().top
                      }, 300);
                    }
                }
            };

            // MutationObserver インスタンスを作成
            var observer = new MutationObserver(callback);
            // オブザーバーの開始：対象ノードとオブザーバーの設定を渡す
            observer.observe(targetNode, config);
        }
    }
  });
})(jQuery);

jQuery(document).ready(function($){
  //$('body').fadeIn(0);
  $('.search-icon').click(function(e){
    e.preventDefault();
    $('.search-form-mobile').slideToggle();
  });
  $('.controller__link').click(function(e){
    e.preventDefault();
    $(this).parents('form').submit();
  });
  var btn = $('.back-to-top');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });
    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });
    
    $(window).on('scroll', function(event) {
    event.preventDefault();
    if($(window).width() >300){
      if( $(this).scrollTop() > 300 ) {
        $('header').addClass('sticky');
      } else {
        $('header').removeClass('sticky');
      }
    }
  });
  $('body').on('click','.sidebar-icon',function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent('a').siblings('ul').toggleClass('show').parents('li').siblings('li').find('ul').removeClass('show');
      $(this).parents('li').siblings('li').find('.sidebar-icon').removeClass('active');
  });
  if ($(window).width() < 769) {
    if ( window.location.pathname == '/' ){
      const bestSellingElement = document.querySelector(".product-best-selling");
      const newArrivalsElement = document.querySelector(".product-new-arrivals");
      if (bestSellingElement) {
        let flkty = new Flickity(bestSellingElement, {
          autoPlay: true,
          autoPlay: 5000,
          contain: true,
          pageDots: true
        });
      }
      if (newArrivalsElement) {
        let flkty2 = new Flickity(newArrivalsElement, {
          autoPlay: true,
          autoPlay: 5000,
          contain: true,
          pageDots: true
        });
      }
    }
  };
  if ($(window).width() > 480) {
    const desktopCarousel = document.querySelector(".carousel-desktop .main-carousel");
    if (desktopCarousel) {
      let flkty = new Flickity(desktopCarousel, {
        wrapAround: true,
        autoPlay: true,
        autoPlay: 5000,
        pageDots: false,
        responsive: [
        {
          breakpoint: 769,
          settings: {
            wrapAround: false,
          }
        }
      ]
      });
    flkty.on('settle', function (index) {
    if (flkty.resizeQueued) {
      flkty.resizeQueued = false;
      flkty.onresize();
    }
      });
      window.addEventListener('resize', function () {
        if (flkty.isAnimating) {
          flkty.resizeQueued = true;
        } else {
          flkty.onresize();
        }
      });
    }
  } else {
    const mobileCarousel = document.querySelector(".carousel-mobile .main-carousel");
    if (mobileCarousel) {
      let flkty = new Flickity(mobileCarousel, {
        autoPlay: true,
        autoPlay: 5000,
        pageDots: false,
        wrapAround: true,
      });
    flkty.on('settle', function (index) {
    if (flkty.resizeQueued) {
      flkty.resizeQueued = false;
      flkty.onresize();
    }
      });
      window.addEventListener('resize', function () {
        if (flkty.isAnimating) {
          flkty.resizeQueued = true;
        } else {
          flkty.onresize();
        }
      });
    }
  };
  
  
  var count=0;
  $('.page-width h3').each(function(){
    var post_id = $(this).parents('.page-width').attr('post_id');
    count++;
    $(this).attr('id','item-'+post_id+'-'+count);
  });
 /* $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 300);
    }); */
  $('.trigger-sidebar').on('click',function (e) {
    e.preventDefault();
    $('.sidebar-left').addClass('show');
    $('.overlay').show();
  });
  $('.overlay').on('click',function(e){
    e.preventDefault();
    $(this).hide();
    $('.sidebar-left').removeClass('show');
  });
  $('.js-videoPoster').on('click',function(e){
    e.preventDefault;
    var poster = $(this);
    var wrapper = poster.closest('.js-videoWrapper');
    videoPlay(wrapper);
  });
  function videoPlay(wrapper) {
    var iframe = wrapper.find('.js-videoIframe');
  var src = iframe.data('src');
  wrapper.addClass('videoWrapperActive');
  iframe.attr('src',src);
  }
});
